// extracted by mini-css-extract-plugin
module.exports = {"list":"dropletSection-module--list--YUxKe","section":"dropletSection-module--section--hcSdA"};